<template>
  <b-dropdown-item
    ref="dropdown"
    class="base-dropdown-menu"
    :class="`${props.className} tw-text-[#231F20]`"
    @click="selected = !selected"
  >
    <slot>
      <button
        v-if="typeof props.selected === 'boolean'"
        class="select-icon-button tw-mr-[12px]"
      >
        <img
          v-show="selected"
          src="/img/elipse_selected_icon.svg"
          alt="eclipse_icon"
        />
        <img v-show="!selected" src="/img/elipse_icon.svg" alt="eclipse_icon" />
      </button>
      {{ props.text }}
    </slot>
  </b-dropdown-item>
</template>
<script setup lang="ts">
import { PropType, onUpdated, ref } from "vue";
const dropdown = ref(null);
type IData = {
  id: string;
  text: string;
  selected: boolean;
};
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  selected: {
    type: Boolean,
    default: null,
  },
  className: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    required: true,
  },
  data: {
    type: Object as PropType<IData>,
    default: () => ({}),
  },
  colorTextHover: {
    type: String,
    default: "#16181b",
  },
});
let selected = ref(props.selected);

onUpdated(() => {
  selected.value = props.selected;
});
</script>
<style lang="scss">
.dropdown-item:hover {
  color: v-bind(colorTextHover) !important;
}
.dropdown-menu {
  border-top: none;
  border-left: 1px solid #eff0f1;
  border-right: 1px solid #eff0f1;
  border-bottom: 1px solid #eff0f1;
  background-color: #fff;
  padding: 0;
  margin-top: 0;

  &.show {
    max-height: 170px;
    overflow: auto;
  }
}

.dropdown-item.normal-dropdown-container {
  padding: 18px 24px;
  font-size: 13px;
  font-weight: 400;
  border-top: 1px solid #eff0f1;
  background-color: #fff;
  box-shadow: none;
  width: 100%;
  height: 56px;

  // &:hover,
  // &:focus,
  // &:active,
  // &:active:focus {
  //   background-color: #EFF0F1;
  //   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  // }
}

.normal-dropdown-container {
  width: 100%;

  .btn-secondary {
    width: 100%;
    text-align: left;
    line-height: 100%;
    padding: 19px 25px;
    color: #211f58;
    font-size: 15px;
    font-weight: 500;
    background-color: #fff;
    border: 1px solid #eff0f1;
    // box-shadow: none;

    // &:hover,
    // &:focus,
    // &:active,
    // &:active:focus {
    //   color: #211F58;
    //   font-size: 15px;
    //   font-weight: 500;
    //   background-color: #FFF;
    //   border: 1px solid #EFF0F1;
    //   box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
    // }
  }

  .dropdown-toggle::after {
    display: none;
  }

  .select-icon-button {
    background-color: transparent;
    // border: none;
  }
}
</style>
